import VueFab from 'vue-float-action-button'
import Vue from 'vue'

Vue.use(VueFab,{
  iconType: 'MaterialDesign'
})
